export default {
  NEW_UI_JULY_2019: 'NEW_UI_JULY_2019',
};
